import { Link } from "react-router-dom";
import { API_BASE_URL, formatDuration, openInGoogleMaps } from "../../utils";
import "./BidNewCard.css";
import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import buffe from "../image/buffe.png";
import { IoLocationOutline } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";

import { BiDrink } from "react-icons/bi";
import TextRoller from "./TextRoller";
import PlatformChargesTooltip from "./PlatformChargesTooltip";
import ShareModal from "../../Feed Page/custom-comp/ShareModal";
import { useState } from "react";
import { CiHeart } from "react-icons/ci";
import { HiOutlineLocationMarker } from "react-icons/hi";
import MoreFeatureShow from "./MoreFeatureShow";

const url = `${API_BASE_URL}/master/assets/uploads/`;
export default function BidNewCard({ data, isBid, isFiltered }) {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareTitle, setShareTitle] = useState("");
  const [currentShareUrl, setCurrentShareUrl] = useState("");
  const [showMoreModal, setShowMoreModal] = useState(false);

  const format = (str) =>
    str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";
  function generateClubUrl(clubName, cityName, areaName, title) {
    const format = (str) =>
      str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";

    return `/party-package/${format(clubName)}-${format(cityName)}-${format(
      areaName
    )}/${format(title)}`;
  }

  function generateClubDetailUrl(clubName, cityName, areaName, title) {
    const format = (str) =>
      str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";

    return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
  }

  const messages = [
    `choose this Now! ₹${data?.discount} would be Saved Instantly on This Booking!`,
    `choose this Now! ₹${data?.discount} would be Saved Instantly !`,
  ];

  const BidDetailUrl = (clubSlug, title, id) => {
    return `${API_BASE_URL}/bid-detail/${format(clubSlug)}/${format(
      title
    )}/${id}`;
  };

  const generateEventUrl = (slug1, slug2) => {
    return `${API_BASE_URL}/event/${slug1}/${slug2}`;
  };

  const handleShare = (e, eventData) => {
    e.preventDefault();
    e.stopPropagation();

    let url = BidDetailUrl(eventData.club_slug, eventData.title, eventData.id);

    setCurrentShareUrl(url);
    setShareTitle(
      `Check out ${eventData.clubName}${
        eventData.title ? " - " + eventData.title : ""
      }`
    );
    setIsShareModalOpen(true);
  };

  return (
    <>
      <div className="bid-new-card">
        <div
          className="event-new-card-image-section position-relative"
          style={{
            backgroundImage: `url(${url + data?.clubLogo})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
          <div className="event-detail-page-design-content1-img-blur-overlay">
            <div className="icon-seton-image">
              <div className="d-flex gap-2">
                <div
                  className="pnats-icon-wrapper-icon-desktop icon cursor-pointer"
                  onClick={(e) => handleShare(e, data)}>
                  <CiHeart size={22} />
                </div>
                <div
                  className="pnats-icon-wrapper-icon-mobile icon cursor-pointer "
                  onClick={(e) => handleShare(e, data)}>
                  <PiShareFatLight size={22} />
                </div>
              </div>
            </div>

            <img
              src={url + data?.clubLogo}
              alt=""
              onError={(e) => {
                e.target.onerror = null; // prevent infinite loop
                e.target.src =
                  "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
              }}
            />
          </div>
        </div>

        <div className="bid-new-card-image-section-wrapper">
          <div className="bid-new-card-content-section">
            <div className="bid-new-card-text-section-wrapper">
              <div className="bid-new-card-text-section">
                <div className="recemmended position-relative">
                  <div className="bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="260"
                      height="30"
                      viewBox="0 0 283 30"
                      fill="none">
                      <path
                        d="M12.8726 2.85857C14.8971 1.01914 17.5343 0 20.2697 0H271.468C281.885 0 286.466 13.1337 278.31 19.6132L268.239 27.6132C266.293 29.1587 263.882 30 261.397 30H11.4646C1.40876 30 -3.37511 17.6208 4.06755 10.8586L12.8726 2.85857Z"
                        fill="url(#paint0_linear_2289_53388)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_2289_53388"
                          x1="-20.9002"
                          y1="29.3636"
                          x2="75.6907"
                          y2="-121.42"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#7464E4" />
                          <stop offset="1" stop-color="#1A00D2" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="r-content">
                    <p class="font-12">
                      {" "}
                      <span>Highest Price</span> |{" "}
                      <span className="d-flex gap-1 align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none">
                          <path
                            d="M0.861538 2.90769C0.861538 1.71816 1.82585 0.753846 3.01538 0.753846H10.9846C12.1742 0.753846 13.1385 1.71816 13.1385 2.90769V11.2C13.1385 12.3895 12.1742 13.3538 10.9846 13.3538H3.01538C1.82585 13.3538 0.861538 12.3895 0.861538 11.2V2.90769Z"
                            fill="#141420"
                          />
                          <path
                            d="M12.0755 0H1.92454C0.861456 0 0 0.861456 0 1.92454V12.0755C0 13.1385 0.861456 14 1.92454 14H12.0755C13.1385 14 14 13.1385 14 12.0755V1.92454C14 0.861456 13.1384 0 12.0755 0ZM12.7736 11.4739C12.7736 12.1916 12.1917 12.7736 11.4739 12.7736H2.60147C1.88366 12.7736 1.30182 12.1917 1.30182 11.4739V2.60147C1.30182 1.88366 1.88366 1.30182 2.60147 1.30182H11.4739C12.1917 1.30182 12.7736 1.88366 12.7736 2.60147V11.4739Z"
                            fill="white"
                          />
                          <path
                            d="M6.02222 2.35781H3.13693C2.7473 2.35781 2.43115 2.67395 2.43115 3.06387V5.80522C2.43115 6.19515 2.7473 6.51129 3.13693 6.51129H6.02207C6.41171 6.51129 6.72785 6.19515 6.72785 5.80522V3.06402C6.72785 2.67395 6.41171 2.35781 6.02222 2.35781ZM5.73333 5.54996H3.42582V3.31928H5.73333V5.54996Z"
                            fill="#C9EE25"
                          />
                          <path
                            d="M9.97639 2.35911C8.83025 2.35911 7.90096 3.28855 7.90096 4.43455C7.90096 5.58069 8.83039 6.50999 9.97639 6.50999C11.1224 6.50999 12.0518 5.58055 12.0518 4.43455C12.0518 3.28855 11.1224 2.35911 9.97639 2.35911ZM9.97639 5.48995C9.39354 5.48995 8.92114 5.01755 8.92114 4.43469C8.92114 3.85184 9.39354 3.37944 9.97639 3.37944C10.5592 3.37944 11.0317 3.85184 11.0317 4.43469C11.0317 5.01755 10.5592 5.48995 9.97639 5.48995Z"
                            fill="#C9EE25"
                          />
                          <path
                            d="M6.8902 10.4865L5.06451 7.32491C4.87477 6.99587 4.40034 6.99587 4.2106 7.32491L2.38491 10.4865C2.19517 10.8155 2.43246 11.2265 2.81209 11.2265H6.46302C6.84265 11.2265 7.07994 10.8155 6.8902 10.4865ZM3.71355 10.2076L4.66039 8.56803L5.60722 10.2076H3.71355Z"
                            fill="#C9EE25"
                          />
                          <path
                            d="M11.885 7.45044C11.6877 7.25316 11.3677 7.25316 11.1704 7.45044L8.04895 10.5717C7.85167 10.769 7.85167 11.0891 8.04895 11.2863C8.24623 11.4836 8.56629 11.4836 8.76357 11.2863L11.885 8.16492C12.0823 7.96778 12.0823 7.64772 11.885 7.45044Z"
                            fill="#F0CF66"
                          />
                          <path
                            d="M8.11926 7.37999L7.97851 7.52074C7.82007 7.67918 7.82007 7.93618 7.97851 8.09461L11.2407 11.3568C11.3991 11.5152 11.6561 11.5152 11.8145 11.3568L11.9553 11.216C12.1137 11.0576 12.1137 10.8006 11.9553 10.6422L8.69327 7.37999C8.53469 7.22156 8.27783 7.22156 8.11926 7.37999Z"
                            fill="white"
                          />
                        </svg>{" "}
                        Recommended{" "}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="d-hide w-100">
                  <div className="mobile-view-pirice dpnats-icon-wrapper-kid-p-hide">
                    <div className="bid-new-pnats-icon-wrapper-adult">
                      {/* <h1>Adult Price </h1> */}
                      <h4>MRP ₹{data?.mrp}</h4>
                      <h5>
                        <span className="text-black">
                          {Number(data?.mrp) == Number(data?.price)
                            ? "MRP"
                            : "Offer"}{" "}
                          Price
                        </span>{" "}
                        ₹{data?.price}
                      </h5>

                      <span className="pnats-icon-wrapper-kid-p">
                        Kid’s Price
                      </span>
                    </div>
                    <div>
                      <p className="bid-pnats-icon-wrapper-kid-span">
                        Book Before in <br />
                        <span className="pnats-icon-wrapper-kid-span-time">
                          06 hr 50 min
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <h1>
                  <span className="bid-new-card-img-icon-section-logo">
                    <img
                      src={
                        data?.clubLogo
                          ? url + data.clubLogo
                          : url + data?.profile_pic
                      }
                      alt=""
                    />
                  </span>{" "}
                  {data?.clubName || data?.name}
                </h1>
                <>
                  <div className="bid-new-card-text-section-location">
                    <p>
                      <span className="icon-size-set">
                        <HiOutlineLocationMarker />
                      </span>{" "}
                      {data?.club_address?.length > 24
                        ? data?.club_address?.slice(0, 24) + "..."
                        : data?.club_address}
                    </p>
                    <div
                      className="bid-new-card-text-section-location-distance"
                      onClick={() => openInGoogleMaps(data?.club_address)}>
                      <span>
                        <FaDirections /> {Math.round(data?.distance)} Kms
                      </span>
                    </div>
                  </div>
                  <p>
                    <div className="bid-new-card-img-icon-section-icon">
                      <img src={buffe} alt="" />
                    </div>
                    {data?.title}
                  </p>
                </>

                <>
                  <div className="d-flex flex-row flex-sm-row flex-md-row flex-lg-column  gap-2 align-items-start justify-content-start">
                    <span className="bid-new-card-text-section-time-service  ">
                      Service Time
                    </span>
                    <div className="bid-new-card-text-section-food-time">
                      {data?.foodserving !== "" && (
                        <p>
                          {" "}
                          <IoRestaurant /> {formatDuration(data?.foodserving)}
                        </p>
                      )}
                      {data?.alcoholserving !== "" && (
                        <p>
                          {" "}
                          <BiDrink /> {formatDuration(data?.alcoholserving)}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              </div>
              {/* <div>
                                <div className='pnats-icon-wrapper-icon-mobile' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div>
                            </div> */}
            </div>

            <div className="bid-new-card-about-text-section">
              <div className="pnats-icon-wrapper">
                {/* <div className='pnats-icon-wrapper-icon-desktop' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={25} />
                                </div> */}
                {isFiltered && (
                  <div className="pnats-icon-wrapper-icon pnats-icon-wrapper-icon2">
                    <MdOutlineFilterAlt size={25} />
                    <div className="pnats-icon-wrapper-icon pnats-icon-wrapper-icon3">
                      <MdOutlinePushPin size={10} />
                    </div>
                  </div>
                )}
              </div>

              <div className="m-hide">
                <div className="bid-new-pnats-icon-wrapper-adult ">
                  {/* <h1>Adult Price </h1> */}
                  <h4>MRP ₹{data?.mrp}</h4>
                  <h5>
                    <span className="text-black">
                      {Number(data?.mrp) == Number(data?.price)
                        ? "MRP"
                        : "Offer"}{" "}
                      Price
                    </span>{" "}
                    ₹{data?.price}
                  </h5>
                  <span className="pnats-icon-wrapper-kid-p">
                    Kid’s Price
                  </span>
                </div>
              </div>

              <div className="PackageNewCard-about-text-section">
                <h1>Inclusion</h1>

                <div>
                  <ul className="PackageNewCard-about-text-section-list">
                    {Object.entries(data?.inclusion || {})
                      .filter(([key]) => !["package_name"].includes(key))
                      .slice(0, 2)
                      .map(([key, value], index) => (
                        <li key={index}>
                          {key.replace(/_/g, " ")}: {value}
                        </li>
                      ))}
                  </ul>
                </div>

                {Object.keys(data?.inclusion || {}).length > 2 && (
                  <p
                    onClick={(event) => {
                      event.stopPropagation();
                      setShowMoreModal(true);
                    }}>
                    {Object.keys(data.inclusion).length - 4}+ More
                  </p>
                )}
              </div>

              <div className="pnats-icon-wrapper-kid m-hide">
                <PlatformChargesTooltip
                  content={
                    <div className="platform-charges-tooltip">
                      <p className="platform-charges-tooltip-text">
                        <span>Kids Price : </span>
                        <span>₹{data?.kids_price}</span>
                      </p>
                      {/* <p className='platform-charges-tooltip-text'><span>GST On Platform</span><span>₹0.90</span></p> */}
                    </div>
                  }
                  position="right"></PlatformChargesTooltip>

                <span className="bid-pnats-icon-wrapper-kid-span">
                  Book Before in{" "}
                  <span className="pnats-icon-wrapper-kid-span-time">
                    06 hr 50 min
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex flex-column justify-content-center gap-1">
            <Link
              to={`/bid-detail/${data?.club_slug}/${format(data?.title)}/${
                data?.id
              }`}
              style={{ textDecoration: "none", width: "100%" }}>
              <div className="bid-new-card-text-section-button">
                <button className=" m-hide">View Details</button>
                <div className="bid-new-card-break-line"></div>
                <div className="bid-new-card-text-section-text-wrapper">
                  <TextRoller messages={messages} />
                </div>
              </div>
            </Link>
            <Link
              className="w-100 d-flex flex-column justify-content-center"
              to={`/bid-detail/${data?.club_slug}/${format(data?.title)}/${
                data?.id
              }`}
              style={{ textDecoration: "none", width: "100%" }}>
              <button className="btn text-btn d-hide">View Details</button>
            </Link>
          </div>
        </div>
      </div>

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentShareUrl}
        title={shareTitle}
      />
      <MoreFeatureShow
        isOpen={showMoreModal}
        onClose={() => setShowMoreModal(false)}
        title="Features"
        inclusions={data?.inclusion}
        isBid={true}
      />
    </>
  );
}
